import React from "react";
import { Container, Row, Col } from "shards-react";
import PageTitle from "../components/common/PageTitle";
import ServiceChargeVehicles from "../components/contracts/services/ServiceChargeVehicle";

const ServiceChangeVehiclesView = props => {
  const { id } = props.match.params;

  return (
    <Container fluid className="main-content-container px-4 pb-4">
      <ServiceChargeVehicles id={id} />
    </Container>
  );
};

export default ServiceChangeVehiclesView;
